var map = {
	"./Heroes Legend.ttf": 887,
	"./ProximaNova-Black.otf": 888,
	"./ProximaNova-Bold.otf": 889,
	"./ProximaNova-Extrabold.otf": 890,
	"./ProximaNova-Light.otf": 891,
	"./ProximaNova-Regular.otf": 892,
	"./ProximaNova-Semibold.otf": 893,
	"./heroes_legend-webfont.woff": 894,
	"./heroes_legend-webfont.woff2": 895
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 886;